import React,{Component} from 'react';
import MainPage from './JS/MainPage';
import {BrowserRouter as Router, Route} from "react-router-dom";
import {connect} from 'react-redux';


class App extends Component{
  render(){
    return (
      <div className="App">
      {/* Routing the Application to a path given below and the component displaying will be the MainPage*/}
      <Route path = "/" component ={MainPage}/>
</div>
);
}
}
const mapStateToProps = (state) => {
  console.log(state);
  return {

  }
}
export default connect(mapStateToProps) (App);
